/* Loox multilingual support is enabled in the merchant account.
 * Older PageFly/Loox loaders can overwrite that setting. Preserve the official
 * widget and its query parameters, specifying only its supported UI language.
 * Review text and paid auto-translation are intentionally untouched.
 */
(() => {
  const start = () => {
    const container = document.getElementById('looxReviews');
    const language = container?.dataset.language;
    if (!container || !language || language !== document.documentElement.lang) return;

    const alignLanguage = () => {
      const frame = container.querySelector('iframe#looxReviewsFrame');
      if (!frame || !frame.getAttribute('src')) return;
      let source;
      try { source = new URL(frame.getAttribute('src'), document.baseURI); }
      catch { return; }
      if (source.origin !== 'https://loox.io' ||
          source.pathname !== '/widget/V1-0JIy_W3/reviews/10358954295611') return;
      const heading = container.closest('[data-section-id]')?.querySelector('h3');
      if (heading?.textContent.trim()) frame.title = heading.textContent.trim();
      if (source.searchParams.get('language') === language) return;
      source.searchParams.set('language', language);
      frame.src = source.href;
    };

    new MutationObserver(alignLanguage).observe(container, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['src']
    });
    alignLanguage();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else start();
})();
